var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.383,
    height: 17.384,
    viewBox: "0 0 17.383 17.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.233,20.763H4.529A2.532,2.532,0,0,1,2,18.233V7.529A2.532,2.532,0,0,1,4.529,5H9.881a1,1,0,0,1,0,2H4.529A.53.53,0,0,0,4,7.529v10.7a.53.53,0,0,0,.529.529h10.7a.53.53,0,0,0,.529-.529V12.881a1,1,0,1,1,2,0v5.352A2.532,2.532,0,0,1,15.233,20.763Z",
    transform: "translate(0 -1.56)",
    fill: "#e63027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.175,1.818a2.622,2.622,0,0,1,1.854,4.476l-7.264,7.264a1,1,0,0,1-.465.263l-3.058.765a1,1,0,0,1-1.213-1.213l.765-3.058a1,1,0,0,1,.263-.465l7.264-7.264A2.6,2.6,0,0,1,21.175,1.818ZM14.547,11.947,21.615,4.88a.622.622,0,1,0-.88-.88l-7.068,7.068-.293,1.173Z",
    transform: "translate(-4.412)",
    fill: "#e63027"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.8b736b3aefcdd028e70423c9de88e961.svg";
export { ForwardRef as ReactComponent };